import DOMPurify from 'dompurify';

/**
 * Sanitiza HTML de origem não confiável (conteúdo gerado por IA a partir de
 * feed/scrape externo, ou qualquer texto vindo do backend) antes de injetar
 * via `dangerouslySetInnerHTML`.
 *
 * Allowlist conservadora: tags de formatação de matéria (parágrafo, títulos,
 * ênfase, listas, citação, tabela, link, imagem) — nada de `script`, `style`,
 * iframes ou atributos `on*`/`javascript:`.
 *
 * Único ponto de sanitização do front — reutilize esta função em vez de
 * configurar o DOMPurify por componente.
 */
const ALLOWED_TAGS = [
  'p',
  'br',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'a',
  'ul',
  'ol',
  'li',
  'blockquote',
  'img',
  'figure',
  'figcaption',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'span',
  'div',
  'hr',
  'code',
  'pre',
];

const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'id'];

export function sanitizarHtml(html: string | null | undefined): string {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['on*'],
    ADD_ATTR: ['target'],
  });
}
